import { motion } from 'framer-motion';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router';
import { setIsPageBlocked } from '../../../../App';
import { GO_TO_APPOINTMENTS } from '../../../../routes/paths';
import { setToastType } from '../../../../store/actions/prescriptionPad';
import { getDoc } from '../../../../store/idbHandler';
import { getPrescription, getToastType } from '../../../../store/selectors/prescriptionPad';

const PushSuccessToast: React.FC = () => {
    const toastType = useSelector(getToastType);
    const px = useSelector(getPrescription);
    const dispatch = useDispatch();
    const history = useHistory();

    if (toastType !== 'push-success') {
        return null;
    }

    const gotToQueue = () => {
        setIsPageBlocked(false);
        history.replace(GO_TO_APPOINTMENTS(px?.clinic._id || '', 'today-queue'));
    };

    const closeMe = () => {
        dispatch(setToastType(undefined));
    };

    return (
        <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            className="px-16 py-12 rounded-8 min-w-632 bg-textColor-secondary flex items-center justify-between select-none"
        >
            <div className="flex items-center space-x-8 text-14 text-white pr-24">
                <div className="flex items-center justify-center w-16 h-16">
                    <svg
                        className="w-16 h-16 fill-mds-success"
                        role="img"
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 512 512"
                    >
                        <path d="M256 0C114.6 0 0 114.6 0 256s114.6 256 256 256s256-114.6 256-256S397.4 0 256 0zM371.8 211.8l-128 128C238.3 345.3 231.2 348 224 348s-14.34-2.719-19.81-8.188l-64-64c-10.91-10.94-10.91-28.69 0-39.63c10.94-10.94 28.69-10.94 39.63 0L224 280.4l108.2-108.2c10.94-10.94 28.69-10.94 39.63 0C382.7 183.1 382.7 200.9 371.8 211.8z"></path>
                    </svg>
                </div>
                <p>
                    {`${
                        getDoc()?.loginmeta?.role === 'STAFF'
                            ? 'Updates pushed to doctor!'
                            : 'Updates saved'
                    }`}
                </p>
            </div>
            <p
                onClick={gotToQueue}
                className="text-14 font-700 underline text-white cursor-pointer"
            >
                Go to Queue
            </p>
            <div className="-right-16 -top-12 absolute" onClick={closeMe}>
                <svg
                    className="cursor-pointer"
                    width="32"
                    height="32"
                    viewBox="0 0 32 32"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <g filter="url(#filter0_d_2837_330544)">
                        <circle cx="16" cy="14" r="12" fill="white"></circle>
                    </g>
                    <path
                        d="M19.2656 16.9844C19.5703 17.2656 19.5703 17.7578 19.2656 18.0391C19.125 18.1797 18.9375 18.25 18.75 18.25C18.5391 18.25 18.3516 18.1797 18.2109 18.0391L15.75 15.5781L13.2656 18.0391C13.125 18.1797 12.9375 18.25 12.75 18.25C12.5391 18.25 12.3516 18.1797 12.2109 18.0391C11.9062 17.7578 11.9062 17.2656 12.2109 16.9844L14.6719 14.5L12.2109 12.0391C11.9062 11.7578 11.9062 11.2656 12.2109 10.9844C12.4922 10.6797 12.9844 10.6797 13.2656 10.9844L15.75 13.4453L18.2109 10.9844C18.4922 10.6797 18.9844 10.6797 19.2656 10.9844C19.5703 11.2656 19.5703 11.7578 19.2656 12.0391L16.8047 14.5234L19.2656 16.9844Z"
                        fill="#4C5980"
                    ></path>
                    <defs>
                        <filter
                            id="filter0_d_2837_330544"
                            x="0"
                            y="0"
                            width="32"
                            height="32"
                            filterUnits="userSpaceOnUse"
                            color-interpolation-filters="sRGB"
                        >
                            <feFlood flood-opacity="0" result="BackgroundImageFix"></feFlood>
                            <feColorMatrix
                                in="SourceAlpha"
                                type="matrix"
                                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                                result="hardAlpha"
                            ></feColorMatrix>
                            <feOffset dy="2"></feOffset>
                            <feGaussianBlur stdDeviation="2"></feGaussianBlur>
                            <feColorMatrix
                                type="matrix"
                                values="0 0 0 0 0.447059 0 0 0 0 0.396078 0 0 0 0 0.890196 0 0 0 0.16 0"
                            ></feColorMatrix>
                            <feBlend
                                mode="normal"
                                in2="BackgroundImageFix"
                                result="effect1_dropShadow_2837_330544"
                            ></feBlend>
                            <feBlend
                                mode="normal"
                                in="SourceGraphic"
                                in2="effect1_dropShadow_2837_330544"
                                result="shape"
                            ></feBlend>
                        </filter>
                    </defs>
                </svg>
            </div>
        </motion.div>
    );
};

export default PushSuccessToast;
